import type { CreativeItem } from "@digital-twins/shared-types";
import type { CreativeWorkspaceFilters } from "@/types/creative-library";

export const CREATIVE_PAGE_SIZE = 24;
export const EMPTY_CREATIVE_FILTERS: CreativeWorkspaceFilters = {
  query: "",
  brand: "all",
  scope: "all",
  origin: "all",
  role: "all",
};

/** Literal UI filters over an already-authorized result; never infer Board membership here. */
export function filterCreativeItems(
  items: CreativeItem[],
  filters: CreativeWorkspaceFilters,
  options?: { scopedBrandToken?: string | null },
) {
  const query = filters.query.trim().toLocaleLowerCase();
  const scopedBrand = options?.scopedBrandToken ?? null;
  return items.filter(
    (item) =>
      item.title.toLocaleLowerCase().includes(query) &&
      (filters.brand === "all" ||
        item.brandToken === filters.brand ||
        (item.brandToken == null &&
          scopedBrand !== null &&
          filters.brand === scopedBrand)) &&
      (filters.role === "all" || item.role === filters.role) &&
      (filters.origin === "all" || item.origin === filters.origin) &&
      (filters.scope === "all" ||
        (filters.scope === "mine" && item.isOwner) ||
        (filters.scope === "shared" && !item.isOwner) ||
        (filters.scope === "organization" &&
          item.sharingMode === "organization")),
  );
}
export function normalizeCreativeLibraryRoute(previous: URLSearchParams) {
  const next = new URLSearchParams(previous);
  if (next.get("view") === "boards") next.set("view", "creatives");
  return next;
}
export function selectCreativeBoard(
  previous: URLSearchParams,
  token: string | null,
) {
  const next = new URLSearchParams(previous);
  next.set("view", "creatives");
  next.delete("creative");
  if (token) next.set("board", token);
  else next.delete("board");
  if (token) {
    next.delete("role");
    next.delete("origin");
    next.delete("scope");
  }
  return next;
}
